// @flow
import { handleActions } from "redux-actions";
import {
    deletePostSuccess,
    deletePostFailure,
    reportPostSuccess,
    reportPostFailure,
    copyLink as copyLinkPost
} from "../actions/post.actions";
import Record from "../flow/Record";
import { clearSnackbar } from "../actions/postActionSnackbar.actions";
import {
    deleteCorrectionFailure,
    deleteCorrectionSuccess,
    reportCorrectionFailure,
    reportCorrectionSuccess,
    copyLink as copyLinkCorrection
} from "../actions/correction.actions";

class SnackbarRecord extends Record({
    message: null
}) {
    message: ?string;
}

function showMessage(message) {
    return state => {
        return state.set("message", message);
    };
}

const postActionSnackbar = handleActions(
    {
        [deletePostSuccess]: showMessage(
            "actionSnackbar.Post successfully deleted"
        ),
        [deletePostFailure]: showMessage(
            "actionSnackbar.Oops, something went wrong deleting post"
        ),
        [reportPostSuccess]: showMessage(
            "actionSnackbar.Post successfully reported"
        ),
        [reportPostFailure]: showMessage(
            "actionSnackbar.Oops, something went wrong reporting post"
        ),
        [clearSnackbar]: showMessage(null),
        [deleteCorrectionSuccess]: showMessage(
            "actionSnackbar.Correction successfully deleted"
        ),
        [deleteCorrectionFailure]: showMessage(
            "actionSnackbar.Something went wrong deleting correction"
        ),
        [reportCorrectionSuccess]: showMessage(
            "actionSnackbar.Correction successfully reported"
        ),
        [reportCorrectionFailure]: showMessage(
            "actionSnackbar.Something went wrong reporting correction"
        ),
        [copyLinkPost]: showMessage("actionSnackbar.Link copied"),
        [copyLinkCorrection]: showMessage("actionSnackbar.Link copied")
    },
    new SnackbarRecord()
);

export default postActionSnackbar;



// WEBPACK FOOTER //
// ./src/reducers/postActionSnackbar.reducer.js